module.exports = __webpack_public_path__ + "img/pro_10.37b63014.png";